import React from "react";

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  TableRow,
  Checkbox,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { apiRequest, apiPost } from "../../utils/api_service";
import { API_URL } from "../../constants/api";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import SaveIcon from "@material-ui/icons/Save";

import "./configuration.less";
import commonLabels from "../../constants/messageConstants";
import { ShowToast, toastType } from "../../utils/toast-service";
export default class GroupSectionMapping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accessGroups: [],
      selectedGroup: "2d0f7fd8-1a83-4027-aa00-9b22db73b2e3",
      sectionPermissions: [],
    };
  }

  /**
   * Onload function
   */
  componentDidMount() {
    this.GetAccessGroups();
  }

  /**
   * Get section permission list
   */
  GetSectionPermissionList = () => {
    const { selectedGroup } = this.state;

    apiRequest({
      url:
        API_URL.datacenter.GetSectionMappingByGroup +
        "?groupId=" +
        selectedGroup,
    }).then(({ data: response }) => {
      this.setState({
        sectionPermissions: response || [],
      });
    });
  };

  /**
   * return access groups values
   */
  GetAccessGroups = () => {
    apiRequest({
      url: API_URL.user.GetAccessGroups,
    }).then(({ data: response }) => {
      const groups = (response || []).filter(
        (x) => x.groupName != "DC_Administrator"
      );
      this.setState(
        {
          accessGroups: groups,
          selectedGroup:(groups[0]||{}).objectId
          /* selectedGroup: (response || []).filter(
          (x) => x.groupName != "DC_Administrator"
        )[0].objectId */
          //configuration: configuration
        },
        () => {
          this.GetSectionPermissionList();
        }
      );
    });
  };

  /**
   * call on value change
   * @param {*} value 
   * @param {*} key 
   * @param {*} index 
   */
  handleValueChange = (value, key, index) => {
    const { sectionPermissions } = this.state;

    sectionPermissions[index][key] = value;

    if (sectionPermissions[index]["subSection"] == null) {
      const parentSectionId = sectionPermissions[index]["parentSectionId"];
      sectionPermissions.forEach((x) => {
        if (x.parentSectionId == parentSectionId) {
          x[key] = value;
        }
      });
    }
    this.setState({ sectionPermissions: sectionPermissions });
  };

  /**
   * save group permission mapping
   * @returns 
   */
  SaveGroupPermissionMapping = () => {
    const { sectionPermissions, selectedGroup } = this.state;
    if (selectedGroup === 0 || selectedGroup === undefined) {
      ShowToast(
        "Please select user group",
        toastType.ERROR,
        5000,
        commonLabels.somethingWrong.code
      );
      return;
    }
    sectionPermissions.forEach(function(x) {
      x.objectId = selectedGroup;
    });

    apiPost({
      url: API_URL.datacenter.UpdateSectionMapping,
      postBody: sectionPermissions,
    }).then(({ success: success }) => {
      if (success == true) {
        ShowToast(
          "Group Access Permissions Updated Successfully",
          toastType.SUCCESS,
          5000,
          1908
        );
      } else
        ShowToast(
          commonLabels.somethingWrong.message,
          toastType.ERROR,
          5000,
          commonLabels.somethingWrong.code
        );
      this.GetSectionPermissionList();
    });
  };
  
  render() {
    const {
      accessGroups,
      sectionPermissions,
      selectedGroup,
    } = this.state;
    return (
      <>
        <Table
          aria-labelledby={"tableMenuTitle"}
          size={"small"}
          aria-label={"configuration table"}
        >
          <TableHead>
            <TableRow>
              <TableCell key={"configureHeader"} className={"content-header"}>
                {" "}
                <div className={"content-header"}>
                  {"Access Permissions Configuration\r"}
                </div>{" "}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell key={"configureTableCell"}>
                <div className={"col-xs-12"}>
                  <FormControl style={{ width: "100%" }}>
                    <InputLabel size={"small"} id={"WidgetTypeLabel"}>
                      {"User Group\r"}
                    </InputLabel>
                    <Select
                      required
                      style={{ width: "100%" }}
                      labelId={"WidgetTypeLabel"}
                      id={"WidgetTypeLabelSelect"}
                      value={selectedGroup}
                      defaultValue={selectedGroup}
                      onChange={(event) => {
                        this.setState(
                          { selectedGroup: event.target.value },
                          () => this.GetSectionPermissionList()
                        );
                      }}
                      placeholder={"Select User Group"}
                    >
                      {accessGroups.map((group, index) => (
                        <MenuItem
                          key={"MenuUG" + index}
                          size={"medium"}
                          value={group.objectId}
                        >
                          {group.description}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>{" "}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell
                key={"configureGMHeader"}
                className={"content-header sub-section row co-xs-12"}
              >
                <div className={"content-header row col-xs-12"}>
                  {"Access Permission\r"}
                  <div className={"end-xs col-xs"}>
                    {/* <IconButton
                  className="white-button"
                      color="inherit"
                      size="small"
                      onClick={()=>{this.setState({openCustomizedLayout:true});}}
                    >
                      <DashboardOutlinedIcon fontSize="small"></DashboardOutlinedIcon>
                    </IconButton> */}
                    <Tooltip title={"Save"}>
                      <IconButton
                        className={"white-button"}
                        color={"inherit"}
                        size={"small"}
                        onClick={this.SaveGroupPermissionMapping}
                      >
                        <SaveIcon fontSize={"small"} />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell key={"configureHeaderCell2"}>
                <div className={"col-xs-12"}>
                  <Paper fontSize={"small"}>
                    <TableContainer>
                      <Table
                        aria-labelledby={"tableTitle"}
                        size={"small"}
                        aria-label={"enhanced table"}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell key={"SectionName"}>
                              {" "}
                              {"Section Name"}{" "}
                            </TableCell>
                            <TableCell key={"SubSectionName"}>
                              {" "}
                              {"Sub Section Name"}{" "}
                            </TableCell>
                            <TableCell key={"accessType"}>
                              {" "}
                              {"Access Type"}{" "}
                            </TableCell>
                            <TableCell key={"showDetailInfoData"}>
                              {" "}
                              {"Show Detail Info"}{" "}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {sectionPermissions.map((row, index) => {
                            return (
                              <TableRow key={"tr_SectionName" + index}>
                                <TableCell key={"SectionName" + index}>
                                  {" "}
                                  {row.subSection == null
                                    ? row.parentSection
                                    : ""}{" "}
                                </TableCell>
                                <TableCell key={"subSectionName" + index}>
                                  {" "}
                                  {row.subSection}{" "}
                                </TableCell>
                                <TableCell key={"accessType" + index}>
                                  <FormControl style={{ width: "100%" }}>
                                    <Select
                                      size={"small"}
                                      fontSize={"small"}
                                      required
                                      style={{ width: "100%" }}
                                      id={"accessTypeIdSelect"}
                                      value={row.accessTypeId}
                                      defaultValue={row.accessTypeId}
                                      onChange={(event) => {
                                        this.handleValueChange(
                                          event.target.value,
                                          "accessTypeId",
                                          index
                                        );
                                      }}
                                      placeholder={"Select Access Type"}
                                    >
                                      {/* <MenuItem
                                        key={"MenuAT0"}
                                        size="medium"
                                        value={0}
                                      >
                                        Select
                                      </MenuItem> */}
                                      <MenuItem
                                        key={"MenuAT1"}
                                        size={"medium"}
                                        value={1}
                                      >
                                        {"View Only\r"}
                                      </MenuItem>
                                      <MenuItem
                                        key={"MenuAT2" + index}
                                        size={"medium"}
                                        value={2}
                                      >
                                        {"Add/Update\r"}
                                      </MenuItem>
                                      <MenuItem
                                        key={"MenuAT3" + index}
                                        size={"medium"}
                                        value={3}
                                      >
                                        {"Full Access\r"}
                                      </MenuItem>
                                      <MenuItem
                                        key={"MenuAT4" + index}
                                        size={"medium"}
                                        value={4}
                                      >
                                        {"Hidden\r"}
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </TableCell>
                                <TableCell key={"tc_showData" + index}>
                                  <Checkbox
                                    id={"showData" + index}
                                    key={"showData" + index}
                                    color={"primary"}
                                    size={"small"}
                                    defaultValue={row.showData}
                                    checked={row.showData}
                                    onChange={(event) => {
                                      event.target.checked;
                                      this.handleValueChange(
                                        event.target.checked,
                                        "showData",
                                        index
                                      );
                                    }}
                                  />{" "}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {/* <Dialog open={openCustomizedLayout} close={()=>{this.setState({openCustomizedLayout:false})}} className="white-button" title={"Layout Settings"}>
            <div>Test</div>
          </Dialog> */}
      </>
    );
  }
}
